import {ISrpQueryParams} from '../redux/types';
import {isDefined} from '../../../../types/type-guards';
import transformToVoyagerObject from '../../../utils/transformToVoyagerObject';

import {parseUrlDateString} from '../../../utils/date-utils';
import {appConfig} from '@stencil/hotels-config';
import addDays from '@stencil/date-utils/src/addDays';
import {getUrlParams} from '../../../utils/common-utils';
import {ICheckinCheckoutDate} from '@stencil/hotels-common-reducer/src/types';
import {convertRoomStringFormat} from '../../../utils/room-string-utils';

export function parseMetaUrlToConfig(url: string, params: ISrpQueryParams & {hotelId: string}) {
  const {
    defaultPartner,
    defaultRoomString,
    defaultCheckinOffset,
    defaultCheckoutOffset,
  } = appConfig;
  const {
    partner = defaultPartner,
    cityName,
    cityId,
    hquery = '',
    metaPartner = '',
    hotelId = '',
  } = params;

  let defaultCheckinDate = addDays(new Date(), defaultCheckinOffset);
  let defaultCheckoutDate = addDays(new Date(), defaultCheckoutOffset);

  let checkin: ICheckinCheckoutDate = {date: defaultCheckinDate};
  let checkout: ICheckinCheckoutDate = {date: defaultCheckoutDate};

  let roomString: string = defaultRoomString;
  let ibp: string = '';
  let vendor: string = '';
  let filterStateForStore = {};
  const overriderankvhids = hotelId;
  let checkinCheckoutPresent = false;

  if (isDefined(hquery) && hquery.length > 0) {
    try {
      const {ci = '', co = '', r = defaultRoomString, ibp: ibpFromMeta = '', d = {}} = JSON.parse(
        decodeURIComponent(hquery),
      );
      if (ci || co) {
        checkin.date = (ci && parseUrlDateString(ci)) || checkin.date;
        checkout.date = (co && parseUrlDateString(co)) || checkout.date;
        checkinCheckoutPresent = true;
      } else if (d) {
        const {
          k: APWindow = defaultCheckinOffset,
          l: lengthOfStay = defaultCheckoutOffset - defaultCheckinOffset,
        } = d;
        checkin.date = addDays(new Date(), APWindow);
        checkout.date = addDays(new Date(), APWindow + lengthOfStay);
        checkinCheckoutPresent = true;
      }
      roomString = convertRoomStringFormat(r);
      ibp = ibpFromMeta;
    } catch (err) {
      console.error(err);
    }
  }

  if (url && url.length > 1) {
    try {
      const urlParamObj = getUrlParams(url);
      vendor = urlParamObj?.vendor;
      if (!checkinCheckoutPresent) {
        let query = urlParamObj?.hquery;
        if (query) {
          const {
            ci = '',
            co = '',
            r = defaultRoomString,
            ibp: ibpFromMeta = '',
            d = {},
          } = JSON.parse(query);
          if (ci || co) {
            checkin.date = (ci && parseUrlDateString(ci)) || checkin.date;
            checkout.date = (co && parseUrlDateString(co)) || checkout.date;
            checkinCheckoutPresent = true;
          } else if (d) {
            const {
              k: APWindow = defaultCheckinOffset,
              l: lengthOfStay = defaultCheckoutOffset - defaultCheckinOffset,
            } = d;
            checkin.date = addDays(new Date(), APWindow);
            checkout.date = addDays(new Date(), APWindow + lengthOfStay);
          }
          roomString = convertRoomStringFormat(r);
          ibp = ibpFromMeta;
          checkinCheckoutPresent = true;
        }
      }
      const filterParams = Object.keys(urlParamObj).filter(key => key.indexOf('filter') > -1);
      const locFilterParams = Object.keys(urlParamObj).filter(key => key.indexOf('ls') > -1);
      if (filterParams.length) {
        const parsedFilterObj = JSON.parse(decodeURIComponent(filterParams[0]));
        const filter = parsedFilterObj.filter;
        if (filter.hasOwnProperty('hr')) {
          filter.star = filter.hr;
          delete filter.hr;
        }
        if (filter.hasOwnProperty('l')) {
          filter.locations = filter.l;
          delete filter.l;
        }
        if (filter.hasOwnProperty('hti')) {
          filter.type = filter.hti;
          delete filter.hti;
        }
        if (filter.hasOwnProperty('tgi')) {
          filter.tags = filter.tgi;
          delete filter.tgi;
        }
        // if (filter.stmg) {
        //   hotels.slotSelected = true;
        // }
        filterStateForStore = {filter: {...filter}};
      }
      if (locFilterParams.length) {
        // ! need more typing around here
        const results = JSON.parse(decodeURIComponent(locFilterParams[0]));
        if (
          results &&
          results.ls &&
          results.ls.loc &&
          results.ls.loc.crd &&
          results.ls.loc.crd.length
        ) {
          const loc = results.ls;
          const {crd = []} = loc;
          filterStateForStore = {
            ...filterStateForStore,
            la: crd[0],
            lo: crd[1],
            s: 'nearby',
          };
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  return {
    partner,
    destination: transformToVoyagerObject(
      (isDefined(cityName) && decodeURIComponent(cityName)) || '',
      cityId,
    ),
    checkin,
    checkout,
    roomString,
    metaPartner,
    ibp,
    vendor,
    overriderankvhids,
    filter: {...filterStateForStore},
  };
}
